export default "__VITE_ASSET__6nFeu3QF__"